export default {
  disable: 'Disable',
  enable: 'Enable',
  channel: 'Channel',
  plant: 'Plant',
  addChannel: 'Add Channel',
  addPlant: 'Add Plant',
  errorcode_499: 'SKU list not pass to check',
  errorcode_423: 'Uploaded execl contains repeat SKU: ',
  errorcode_424: 'Excel contains blank product code!',
  errorcode_425: 'There are blanks in  product code!: ',
  errorcode_1603: 'Illegal plant code: ',
  errorcode_1604: 'Illegal channel: ',
  errorcode_801: 'The uploaded file cannot be empty',
  errorcode_821: 'Not excel file',
  errorcode_1111: 'Source file is empty!',
  errorcode_1801: 'Batch insert NFC sku error',
  errorcode_1304: 'Tag Type cannot be empty',
  errorcode_13041: 'Tag type ',
  errorcode_13042: 'doesn’t exist in configuration',
  errorcode_1305: 'Only allow 5 NFC Types',
  disableDataTip: 'Are you sure you want to disable the data?',
  enableDataTip: 'Are your sure want to enable this data?',
  createTime: 'Create Time',
  lastUpdate: 'Last Updated By',
  lastUploadTime: 'Last Upload Time',
  lastUpdateTime: 'Last Update Time',
  uploadDate: 'Last Upload Date',
  createDate: 'Create Date',
  updateDate: 'Last Update Date',
  tagType: 'Tag Type',
  addTagType: 'Add Tag Type',
  editTagType: 'Edit Tag Type',
  tagTypeDesc: 'Tag Type Desc',
  tagTypeName: 'Tag Type Name',
  lastUpdateUser: 'Last Update User',
  // lastUpdateTime: 'Last Update Time',
  default: 'Default',
  defaultTagType: 'Default Tag Type',
  charactersNumbers: 'can’t be longer than 4 characters',
  inputRequire: 'Allow uppercase & lower case letters & numbers',
  descriptionRepeat: 'Tag description already exist!',
  tagTypeRepeat: 'Tag type already exist!',
  totalSKUCount: 'Total SKU Count: ',
  processSuccessCount: 'Process Success Count: ',
  compareWithLastVersion: 'Compare with last version:',
  inactiveSKUCount: 'Inactive SKU Count: ',
  newSKUCount: 'New SKU Count: ',
  upload: 'Upload',
  export: 'Export',
  season: 'Season',
  salesDoor: 'No. sales door',
  averageNo: 'Average display No. in each door',
  uploadSuccess: 'Upload Success',
  uploadStoreDisplay_errorcode_501: 'Season field is required.',
  uploadStoreDisplay_errorcode_502: 'Product code field is required.',
  uploadStoreDisplay_errorcode_503: 'Channel field is required.',
  uploadStoreDisplay_errorcode_504: 'AverageNo field is required.',
  uploadStoreDisplay_errorcode_505: 'Season format should be like SP24.',
  uploadStoreDisplay_errorcode_506: 'Average display No. in each door should be positive integer',
  uploadStoreDisplay_errorcode_507: 'are duplicate.',
  templateName: 'Template Name',
  templateDescription: 'Template Description',
  fieldId: 'Field ID',
  fieldName: 'Field Name',
  action: 'Action',
  editTemplate: 'Edit Template',
  addTemplate: 'Add Template',
  deleteDataTip: 'Are you sure you want to delete the data?',
  templateNameError: `Template Name is required.`,
  fieldListError: 'Please fill at lease one field name.',
  addTemplateError: `Template + Sequence ID + Sequence Name can't be duplicated.`,
  addTemplateError2: `Template Name can't be duplicated.`,
  uploadTagImage: 'Upload Tag Image',
  tagTypeImage: 'Tag Type Image',
  fileSizeErrTip: 'The image size cannot exceed',
  fileExtentionError: 'File extension name must be ',
  exportLatestStoreDisplay: 'Export Latest Store Display',
  addRFDevice: 'Add RF Device',
  editRFDevice: 'Edit RF Device',
  deviceCode: 'Device Code',
  macAddress: 'Wireless LAN Mac Address',
  RFDeviceStatus: 'Status',
  updateTime: 'Update Time',
  errTitleExist: 'Duplicate RF Device Code/Mac Address',
  errMsgExist: 'The RF Device Code/Mac Address already exist in the system.',
  errTitleMac: 'Incorrect Mac Address',
  errMsgMac: 'Please input correct wireless LAN Mac Address, for example: F4-7B-09-40-87-7B',
  errTitleDeviceCode: 'Incorrect Device Code',
  errMsgDeviceCode: 'Please input correct Device Code, for exmple: 1025RFID-XXX-001',
  errTitleModuleConflict: 'RF Device Function Module Conflict',
  errMsgModuleConflict: 'RFID Carton Scan Function is mutually exclusive between 1025 and 1027.',
  disableRFDeviceConfirmInfo: 'Are you sure to disable this RF Device?',
  function: 'Function'
}
